import ApplicationInput from "~/components/application/input";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

const ApplicationBiographyAndJoining = () => {
  const { language } = useLanguage();
  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;

  return (
    <>
      <p>
        {applyTexts.applicationForm.aboutYou.split("<br>").map((text, i) => (
          <p key={i}>{text}</p>
        ))}
      </p>

      <div>
        <p>{applyTexts.applicationForm.shortBio}</p>
        <ApplicationInput
          register="shortBiography"
          placeholder={applyTexts.applicationForm.shortBioText}
          label="short biography"
          size={78}
          type="textarea"
          required
        />
      </div>

      <div>
        <p>{applyTexts.applicationForm.joinSilencio}</p>
        <ApplicationInput
          register="joiningSilencio"
          placeholder={applyTexts.applicationForm.joinSilencioText}
          label="Pourquoi voulez-vous rejoindre Silencio ?"
          size={89}
          type="textarea"
          required
        />
      </div>
    </>
  );
};

export default ApplicationBiographyAndJoining;
